import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=6f0e3e11&scoped=true&lang=html&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e3e11",
  null
  
)

export default component.exports